import { ConfigProvider as AntdConfigProvider } from 'antd'
import { ConfigProviderProps } from 'antd/es/config-provider'
import React, { useEffect } from 'react'

import { isBigScreen, mediaQueryLarge } from '../helpers/LayoutHelper'

export interface DbThemeConfigProviderProps extends ConfigProviderProps {
  children: React.ReactNode
  renk1?: string // Yeni eklenen prop
  renk2?: string // Yeni eklenen prop
}

const ConfigProvider: React.FC<DbThemeConfigProviderProps> = (props) => {
  const { children, renk1 = '#D8263E', renk2 = '#ccc', ...rest } = props

  useEffect(() => {
    const root = document.documentElement

    // `renk1` ana renk olarak ayarlandı
    root?.style.setProperty('--color-primary', renk1)
    root?.style.setProperty('--color-secondary', renk2) // Eğer kullanmak isterseniz

    root?.style.setProperty('--color-primary-light', `color-mix(in srgb, var(--color-primary), #fff 70%)`)
    const handleResize = () => {
      if (isBigScreen.matches) {
        root?.style.setProperty('--max-width-centered-layout', '1520px')
      } else if (mediaQueryLarge.matches) {
        root?.style.setProperty('--max-width-centered-layout', '1520px')
      } else {
        root?.style.setProperty('--max-width-centered-layout', '1440px')
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [renk1, renk2]) // `renk1` ve `renk2` değiştiğinde tekrar çalıştır

  return (
    <AntdConfigProvider
      {...rest}
      theme={{
        token: {
          colorPrimary: renk1, // `renk1` burada `colorPrimary` olarak ayarlandı
          fontFamily: 'QuickSand',
        },
      }}
    >
      {children}
    </AntdConfigProvider>
  )
}

export default ConfigProvider
